import getApiClient from 'src/utils/getApiClient'
import getCSRFToken from 'src/utils/getCSRFToken'

const apiClient = getApiClient()
const PREFIX_BASE64 = 'data:image/jpeg;base64,'

export type DoctorAvatarProcessResponseItem = {
  rotation: number
  crop_coords: string
  upscale_crop_coords?: string | null
  image_with_background: string
  image_without_background: string
  upscale_image_with_background?: string | null
  upscale_image_without_background?: string | null
}

export type DoctorAvatarApiUrls = {
  processAvatar: string
  saveAvatar: string
}

export default {
  process(params: {
    image: string
    doctor_id: number
    rotation?: number
  }, apiUrls: DoctorAvatarApiUrls) {
    return apiClient.post<DoctorAvatarProcessResponseItem[]>(
      apiUrls.processAvatar,
      {
        image: params.image,
        doctor_id: params.doctor_id,
        rotation: params.rotation ?? 0,
      },
      {
        headers: {
          'X-CSRFToken': getCSRFToken(),
          'Content-Type': 'application/json',
        },
      },
    )
      .then(({ data }) => data)
  },

  save(params: {
    source_image: string
    processed_image: string
    crop_coords: string
    rotation: number
    doctor_id: number
  }, apiUrls: DoctorAvatarApiUrls) {
    return apiClient.post(
      apiUrls.saveAvatar,
      params,
      {
        headers: {
          'X-CSRFToken': getCSRFToken(),
          'Content-Type': 'application/json',
        },
      },
    )
  },

  toDataUrl(base64Body: string) {
    if (base64Body.startsWith('data:')) {
      return base64Body
    }

    return `${PREFIX_BASE64}${base64Body}`
  },
}
